/*
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-07-09 14:38:34
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 17:55:41
 */
import { submitErrorLog } from '@/assets/js/common'

import { Toast, Empty } from 'vant'
const oral = {
  myRecord: null,
  tmp: [],
  waveTime: '',
  isRoot: false,
  initEngine() {
    oral.myRecord = new window.EngineEvaluat({
      applicationId: 'a658',
      // 健康检查最长超时时间
      maxHealthyCheckTime: 5000,
      micAllowCallback: function() {
        console.log('麦克风已经允许')
        oral.isRoot = true
      },
      micForbidCallback: function() {
        console.log('麦克风没有被允许')
        oral.isRoot = false
        submitErrorLog('micForbidCallback-麦克风没有被允许', '麦克风没有被允许')
      },
      playAudioComplete: function(data) {
        console.log('播放完毕')
      },
      playAudioError: function(data) {
        console.log('播放出错')
      },
      engineBackResultDone: function(msg) {
        try {
          let data = JSON.parse(msg)
          let resultData = {}
          resultData.duration = data.result.wavetime / 1000
          resultData.audioUrl = data.audioUrl
          resultData.wordInfosArr = []
          if (data.params.request.coreType == 'en.sent.rec') {
            //语音识别
            let arr = data.result.wrd_details
            let str = []
            arr.forEach(el => {
              str.push(el.char)
            })
            resultData.resultStr = str.join(' ')
            resultData.overall = 0
          } else if (data.params.request.coreType == 'en.sent.score') {
            let arr = data.result.details
            arr.forEach(el => {
              resultData.overall = data.result.overall
              resultData.resultStr = data.refText
              resultData.wordInfosArr.push({
                word: el.char,
                score: el.score
              })
            })
          } else if (data.params.request.coreType == 'en.pred.score') {
            resultData.overall = data.result.overall
            resultData.resultStr = data.refText
            let arr = data.result.details
            arr.forEach(el => {
              resultData.wordInfosArr.push(...el.snt_details)
            })
            resultData.wordInfosArr.forEach(el => {
              el.word = el.char
            })
          }
          oralRecAndEvaCallback(JSON.stringify(resultData))
        } catch (error) {
          submitErrorLog('engineBackResultDone-解析数据失败', error)
        }
      },
      engineBackResultFail: function(msg) {
        console.log('评测失败')
        console.log(msg)
        Toast('录音评测失败')
        submitErrorLog('engineBackResultFail-评测失败', msg || '评测失败')
      },
      engineFirstInitDone: function() {
        console.log('初始化成功')
      },
      micVolumeCallback: function(data) {
        console.log('录音音量大小为:' + data)
      },
      JSSDKNotSupport: function(e) {
        // alert('jssdk  not support');
        Toast('录音引擎不支持')
        submitErrorLog('JSSDKNotSupport-录音引擎不支持', e || '录音引擎不支持')
      },
      getRealTimeAudioBuffer: function(audioBuffer) {}
    })
  }
}
export default oral
